var height = $('body').outerHeight();
var bpMessage = '{  "IframeWindowHeight":"' + height + '" }';
window.parent.postMessage(bpMessage, '*');
console.log('Body Height after Post Mesage :', height);
